import { Box } from "@chakra-ui/react";

export function GradientDivider() {
  return (
    <Box
      width="100%"
      height="1px"
      background="linear-gradient(to right, rgba(255,255,255,0.2), rgba(255,255,255,0.1))"
    />
  );
}
